import { Vector3 } from "three"
import type { NeighborWaterCurrentCollection } from "../../../../rx/memo/useNodeNeighborBaseWaterCurrentReactiveMap"
import { VERTICES_PER_TILE } from "../../consts"
import getNeighborWeightsV2Cached from "../TerrainMesh1V2/getNeighborWeightsV2Cached"
import calculateNodeWaterCurrent from "./calculateNodeWaterCurrent"

const halfSize = VERTICES_PER_TILE / 2

export default function setTileRelativeWaterCurrentVector3 (
  baseWaterCurrentsCollection: NeighborWaterCurrentCollection,
  tileRelativeX: number,
  tileRelativeY: number,
  outV3 : Vector3): void {
  // Normalize coordinates to [-1, 1] range for weight calculation
  const nx = tileRelativeX / halfSize
  const ny = tileRelativeY / halfSize

  // Get cached weights based on distance from tile boundaries
  const vertexWeights = getNeighborWeightsV2Cached(nx, ny)

  // Calculate weighted elevation using neighbor influence
  calculateNodeWaterCurrent(vertexWeights, baseWaterCurrentsCollection, outV3)
  // console.log('outV3', outV3, baseWaterCurrentsCollection)
}